import { render, staticRenderFns } from "./CompressIcon.vue?vue&type=template&id=0b4b5eac"
import script from "./CompressIcon.vue?vue&type=script&lang=js"
export * from "./CompressIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports